/**
 * A full page load.
 *
 * For the two moments the router is wrong: leaving for an identity provider,
 * whose round trip has to carry the browser's own cookies; and handing an
 * impersonated session back to the administrator, where nothing the other
 * person's screens cached may survive into the administrator's own.
 *
 * An object rather than a bare function so a test can replace `assign`: jsdom
 * does not implement navigation, and `window.location` cannot be spied on.
 */
export const hardNavigation = {
  assign(url: string): void {
    window.location.assign(url);
  },
};
